const React = require("react");

const FolderIcon = React.createClass({
    render() {
        return (<span className="glyphicon glyphicon-folder-close" style={this.props.style }></span>);
    }
});

module.exports = FolderIcon;


// WEBPACK FOOTER //
// ./src/components/FolderIcon.jsx